// grade-web.ts — 1:1 JS port of src-tauri/src/grade.rs: deterministic grade → ordinal.
// Higher = harder; -1 = unparseable. Only ordering/deltas matter; raw grade strings are
// what customers ever see. Keep in sync with the Rust — it is the shipping source of truth.

export function gradeValue(raw: string): number {
  const s = raw.trim().toLowerCase().replaceAll(" ", "");
  if (!s) return -1;
  return parseVScale(s) ?? parseYds(s) ?? parseFrench(s) ?? -1;
}

function parseVScale(s: string): number | null {
  if (!s.startsWith("v")) return null;
  const rest = s.slice(1);
  if (rest === "b" || rest === "-easy") return 95;
  let num = "";
  for (const c of rest) { if (/[0-9]/.test(c)) num += c; else break; }
  if (!num) return null;
  const n = Number(num);
  if (n > 17) return null;
  let val = 100 + n * 5;
  if (rest.includes("+")) val += 2;
  else if (rest.includes("-")) val -= 2;
  return val;
}

function parseYds(s: string): number | null {
  if (!s.startsWith("5.")) return null;
  const rest = s.slice(2);
  let digits = "";
  for (const c of rest) { if (/[0-9]/.test(c)) digits += c; else break; }
  if (!digits) return null;
  const major = Number(digits);
  if (major < 0 || major > 15) return null;
  const letter = rest[digits.length];
  const sub = letter === "a" ? 0 : letter === "b" ? 1 : letter === "c" ? 2 : letter === "d" ? 3
    : letter === "+" ? 2 : letter === "-" ? 0 : 1;
  return major < 10 ? 80 + major * 4 : 120 + (major - 10) * 4 + sub;
}

function parseFrench(s: string): number | null {
  const first = s[0];
  if (!/[0-9]/.test(first)) return null;
  const major = Number(first);
  if (major < 1 || major > 9) return null;
  const rest = s.slice(1);
  const letter = rest[0];
  let sub: number;
  if (letter === "a") sub = 0;
  else if (letter === "b") sub = 3;
  else if (letter === "c") sub = 6;
  else if (letter === undefined) sub = 0;
  else return null; // must be a/b/c to be a real French grade (avoids matching "5.10")
  const plus = rest.includes("+") ? 1 : 0;
  return 80 + (major - 4) * 9 + sub + plus;
}
